import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_secure/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/general", search: {} }); // eslint-disable-line @typescript-eslint/only-throw-error
  },
});
